var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0000610352,
    width: 24.7527,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2615 19.5H4.76154C4.45404 19.5 4.19904 19.245 4.19904 18.9375C4.19904 18.63 4.45404 18.375 4.76154 18.375H18.2615C18.569 18.375 18.824 18.63 18.824 18.9375C18.824 19.245 18.569 19.5 18.2615 19.5Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7765 5.61C15.3215 4.155 13.8965 4.1175 12.404 5.61L11.4965 6.5175C11.4215 6.5925 11.3915 6.7125 11.4215 6.8175C11.9915 8.805 13.5815 10.395 15.569 10.965C15.599 10.9725 15.629 10.98 15.659 10.98C15.7415 10.98 15.8165 10.95 15.8765 10.89L16.7765 9.9825C17.519 9.2475 17.879 8.535 17.879 7.815C17.8865 7.0725 17.5265 6.3525 16.7765 5.61Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.219 11.6475C14.0015 11.5425 13.7915 11.4375 13.589 11.3175C13.424 11.22 13.2665 11.115 13.109 11.0025C12.9815 10.92 12.8315 10.8 12.689 10.68C12.674 10.6725 12.6215 10.6275 12.5615 10.5675C12.314 10.3575 12.0365 10.0875 11.789 9.78751C11.7665 9.77251 11.729 9.72001 11.6765 9.65251C11.6015 9.56251 11.474 9.41251 11.3615 9.24001C11.2715 9.12751 11.1665 8.96251 11.069 8.79751C10.949 8.59501 10.844 8.39251 10.739 8.18251C10.6014 7.8875 10.2142 7.79987 9.98397 8.03006L5.76653 12.2475C5.66903 12.345 5.57903 12.5325 5.55653 12.66L5.15153 15.5325C5.07653 16.0425 5.21903 16.5225 5.53403 16.845C5.80403 17.1075 6.17903 17.25 6.58403 17.25C6.67403 17.25 6.76403 17.2425 6.85403 17.2275L9.73403 16.8225C9.86903 16.8 10.0565 16.71 10.1465 16.6125L14.3709 12.3881C14.5965 12.1625 14.5118 11.7744 14.219 11.6475Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e2dccb2e9044e4fdadb9500c5270303d.svg";
export { ForwardRef as ReactComponent };